import { api } from "./client";

export interface Prophet {
  id: string;
  name: string;
  short_description: Record<string, string>;
  long_description: Record<string, string>;
  investment_philosophy: Record<string, string>;
  image_url: string | null;
}

export interface ProphetMessage {
  role: "user" | "assistant";
  content: string;
}

export interface ProphetChatResponse {
  conversation_id: string;
  reply: string;
  has_data_changes: boolean;
  budget_exceeded: boolean;
}

export interface ProphetConversation {
  id: string;
  prophet_id: string;
  title: string | null;
  created_at: string;
  updated_at: string;
}

export const prophetsApi = {
  async listProphets(): Promise<Prophet[]> {
    const { data } = await api.get<Prophet[]>("/api/prophets");
    return data;
  },

  async chat(
    prophetId: string,
    payload: { conversation_id?: string | null; message: string }
  ): Promise<ProphetChatResponse> {
    const { data } = await api.post<ProphetChatResponse>(
      `/api/prophets/${prophetId}/chat`,
      payload
    );
    return data;
  },

  async listConversations(prophetId?: string): Promise<ProphetConversation[]> {
    const { data } = await api.get<ProphetConversation[]>("/api/prophets/conversations", {
      params: prophetId ? { prophet_id: prophetId } : undefined,
    });
    return data;
  },

  async deleteConversation(conversationId: string): Promise<void> {
    await api.delete(`/api/prophets/conversations/${conversationId}`);
  },
};
